import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { AboutSectionComponent } from './sections/about/about-section.component';
import { ContactSectionComponent } from './sections/contact/contact-section.component';
import { ExperienceSectionComponent } from './sections/experience/experience-section.component';
import { FaqSectionComponent } from './sections/faq/faq-section.component';
import { GallerySectionComponent } from './sections/gallery/gallery-section.component';
import { FeedbackSectionComponent } from './sections/feedback/feedback-section.component';
import { HeroSectionComponent } from './sections/hero/hero-section.component';
import { JourneySectionComponent } from './sections/journey/journey-section.component';
import { ServicesSectionComponent } from './sections/services/services-section.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HeroSectionComponent,
    AboutSectionComponent,
    GallerySectionComponent,
    FaqSectionComponent,
    FeedbackSectionComponent,
    ContactSectionComponent,
    JourneySectionComponent,
    ExperienceSectionComponent,
    ServicesSectionComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent {}
